import reactUpdate from 'immutability-helper';
import _ from 'underscore';

import {BenchlingAction} from 'redux-stores/Action';
import {SampleGroupActionType} from 'workflows/samples/SampleGroupReduxActions';

import {SampleGroup} from './WorkflowConstants';

export interface SampleGroupsState {
  sampleGroupsById: {[id: string]: SampleGroup};
}

export const SAMPLE_GROUPS_INITIAL_STATE = {
  sampleGroupsById: {},
};

export default function reduceSampleGroups(
  state: SampleGroupsState = SAMPLE_GROUPS_INITIAL_STATE,
  action: BenchlingAction
): SampleGroupsState {
  switch (action.type) {
    case SampleGroupActionType.SAMPLE_GROUPS_FETCH_COMPLETED: {
      const {sampleGroups} = action;
      return reactUpdate(state, {
        sampleGroupsById: {
          $merge: _.indexBy(sampleGroups, 'id'),
        },
      });
    }

    default:
      return state;
  }
}
